import { useQuery } from '@tanstack/react-query';
import { CalendarResponse } from '../../../../types/Calendar';
import CustomAxios from '../../../../utility/customAxios';
import { queryKeys } from '../../queryKeys';

export type UseGetOutlookCalendarsProps = {
  enabled?: boolean;
};

export const fetchOutlookCalendars = async () => {
  const response = await CustomAxios.get<CalendarResponse>(`integrations/outlook/calendars`);
  const { data } = response;
  return data;
};

export function useGetOutlookCalendars({ enabled = true }: UseGetOutlookCalendarsProps) {
  const queryKey: any = [queryKeys.outlookCalendars];
  const query = useQuery({
    enabled,
    queryKey,
    queryFn: fetchOutlookCalendars,
  });
  return query;
}
